import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api, { fileUrl } from "../lib/api";
import { useLang } from "../context/LanguageContext";

const FALLBACK = "https://images.unsplash.com/photo-1549611016-3a70d82b5040?auto=format&fit=crop&w=1000&q=80";

export const News = () => {
  const { t, pick } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/news").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const fmt = (d) => new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });

  return (
    <div>
      <section className="bg-brand-green grain">
        <div className="mx-auto max-w-7xl px-5 py-16">
          <h1 className="font-display text-5xl font-black tracking-tighter sm:text-7xl">{t("news_title")}</h1>
          <p className="mt-4 max-w-xl text-lg text-brand-ink/80">{t("news_sub")}</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-14">
        {items.length === 0 && <p className="text-muted-foreground">No news yet.</p>}
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {items.map((n) => (
            <Link to={`/news/${n.id}`} key={n.id} data-testid={`news-card-${n.id}`} className="group flex flex-col overflow-hidden rounded-3xl border-2 border-brand-ink bg-white hover-brutal">
              <img src={n.image_path ? fileUrl(n.image_path) : FALLBACK} alt={pick(n, "title")} className="aspect-[16/10] w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="flex flex-1 flex-col p-5">
                <span className="text-xs font-bold uppercase tracking-widest text-brand-greendark">{fmt(n.created_at)}</span>
                <h3 className="mt-2 font-display text-2xl font-bold leading-tight">{pick(n, "title")}</h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm text-muted-foreground">{pick(n, "content")}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-bold text-brand-greendark">{t("read_more")} <ArrowRight className="h-4 w-4" /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default News;
